<template>
    <div class="container">
        <Loading v-show="loading"/>
        <BallCreate @submitEvent="openMatterInfo({})"/>
        <div class="header-date">
            <div class="top-left">
                <div class="view-type my-cursor"
                     :style="{color: navName === navItem ? 'var(--color-normal)': '#333333'}"
                     v-for="navItem in navItems"
                     @click="setNavName(navItem)">
                    {{ navItem }}
                    <div class="bottom-border" :style="{'visibility': navItem === navName ? 'visible':'hidden'}"></div>
                </div>
            </div>

            <div class="top-center">
                <div class="icon-today-month my-cursor"
                     style="visibility:hidden">
                </div>
                <div class="icon-prev-month my-cursor" @click="pageTuring('prev')"></div>
                <div class="text-title">{{ titleDate }}</div>
                <div class="icon-next-month my-cursor" @click="pageTuring('next')"></div>
                <div class="icon-today-month my-cursor"
                     :style="{'visibility': backToday}"
                     @click="pageTuring('current')">
                </div>
            </div>
            <div class="top-right">
                <div class="item-category my-cursor" @click="switchCategory()">
                    全部分类
                    <div class="icon-category"></div>
                </div>
            </div>
        </div>


        <CategoryManage v-if="categoryState"
                        @closeEvent="switchCategory"/>

        <DayMatters v-if="dayState"
                    :dayItem="dayItem"
                    @closeEvent="switchDay"
                    @clockEvent="saveClockEvent($event)"
                    @matterEvent="saveMatterEvent($event)"
        />
        <MatterInfo v-if="infoState"
                    :clockTargetDate="clockTargetDate"
                    :matterItem="matterItem"
                    @submitEvent="saveInfoEvent"
                    @closeEvent="switchInfo"/>

        <ViewMonth ref="viewMonth" v-if="navName === '月视图'"
                   @dayEvent="saveDayEvent($event)"
                   @matterEvent="saveMatterEvent($event)"
                   @cycleEvent="saveTodayCycle($event)"
        />

        <ViewWeek ref="viewWeek" v-if="navName === '周视图'"
                  @dayEvent="saveDayEvent($event)"
                  @matterEvent="saveMatterEvent($event)"
                  @cycleEvent="saveTodayCycle($event)"
        />

        <ViewDay ref="viewDay" v-if="navName === '日视图'"
                 @dayEvent="saveDayEvent($event)"
                 @matterEvent="saveMatterEvent($event)"
                 @cycleEvent="saveTodayCycle($event)"
        />

    </div>
</template>

<script>
import Loading from "../Public/Loading";
import BallCreate from "../List/BallCreate";

import CategoryManage from "../List/CategoryManage";
import MatterInfo from "../List/MatterInfo";
import DayMatters from "./DayMatters";

import ViewDay from "./ViewDay";
import ViewWeek from "./ViewWeek";
import ViewMonth from "./ViewMonth";

import { mapState, mapMutations } from "vuex";
import listClockData from "@/utils/List/listClockData";

export default {
    name: "index",
    components: {
        Loading,
        BallCreate,
        CategoryManage,
        MatterInfo,
        DayMatters,
        ViewMonth,
        ViewWeek,
        ViewDay
    },
    data(){
        return {
            categoryState: false,
            dayState: false,
            infoState: false,
            navName: "",
            navItems: ["日视图", "周视图", "月视图"],
            backToday: "hidden",
            titleDate: "",
            cycleFirstDay: "",
            selectDayStr: "",
            dayItem: {},
            matterItem: {},
            clockTargetDate: "",
        }
    },
    computed: {
        ...mapState(["vipInfo"]),
        ...mapState("listModules", ["optId", "loading", "categoryShowId"])
    },
    watch: {
        categoryShowId: function(newValue, oldValue){
            if(oldValue === "default"){
                return
            }
            this.updateClockEvent();
        },
    },
    methods: {
        ...mapMutations("listModules", ["setLoading", "initListData", "setOptId", "setList", "setClock", "setDeleteData"]),
        switchCategory: function(){
            this.categoryState = !this.categoryState;
        },
        switchDay: function(){
            this.dayState = !this.dayState;
        },
        switchInfo: function(){
            this.infoState = !this.infoState;
        },
        getListInfo: function(){
            this.$api.getSyncList({
                optId: -1,
                listInfoList: [],
                listChildList: [],
                listClockList: [],
                listCategoryList: [],
                listTimeLineList: [],
                listDeleteList: [],
            }).then((res)=>{
                this.setLoading(false);
                if(res.data.code === 200){
                    this.initListData(res.data.data);
                    this.setNavName("月视图");
                }else{
                    this.$PopupToast("清单数据请求失败")
                }
            })
        },
        /**
         * 切换视图
         */
        setNavName: function(navName){

            this.navName = navName;
            this.cycleFirstDay = "";
        },
        getChildView: function(){
            let childView;
            if(this.navName === "月视图"){
                // 月视图
                childView = this.$refs.viewMonth;
            }else if(this.navName === "周视图"){
                // 周视图
                childView = this.$refs.viewWeek;
            }else{
                // 日视图
                childView = this.$refs.viewDay;
            }
            return childView
        },
        /**
         * 切换周期
         */
        pageTuring: function(turingType){
            const childView =  this.getChildView();
            childView.getCycleDayItems(turingType);
        },
        saveTodayCycle: function(e){
            this.titleDate = e.titleDate;
            this.clockTargetDate = e.selectDayStr;
            if (this.cycleFirstDay === ""){
                this.cycleFirstDay = e.cycleFirstDay;
            }
            if(this.cycleFirstDay === e.cycleFirstDay){
                this.backToday = "hidden";
            }else{
                this.backToday = "";
            }
        },
        openMatterInfo: function(){
            this.matterItem = {};
            this.switchInfo();
        },
        saveDayEvent: function(e){
            this.dayItem = e;
            this.clockTargetDate = e.date;
            this.switchDay();
        },
        saveClockEvent: function(e){
            const listClockList = listClockData.getClockData(e.matterItem, e.childItem);
            this.sendRequest(listClockList)
        },

        saveMatterEvent: function(e){
            this.matterItem = e;
            this.childItem = {};
            this.switchInfo();
        },
        saveInfoEvent: function(){
            // 更新
            this.updateClockEvent();
        },
        sendRequest: function(listClockList){
            const that = this;
            const params = {
                optId: this.optId,
                listInfoList: [],
                listClockList: listClockList,
                listCategoryList: [],
                listChildList: [],
                listTimeLineList: [],
                listDeleteList: [],
            }
            this.setLoading(true);
            this.$api.getSyncList(params).then((res)=>{
                that.setLoading(false);
                if(res.data.code === 200 && !res.data.data.differenceData){
                    that.setClock(listClockList);
                    that.setOptId(res.data.data.lastOptId);
                    that.updateClockEvent();
                }else{
                    that.$PopupToast("保存失败");
                }
            })
        },
        updateClockEvent: function(){
            const childView = this.getChildView();
            childView.updateMatterItem();
            for(let i=0, l=childView.dayItems.length; i<l;i++){
                if(childView.dayItems[i].date === childView.selectDayStr){
                    this.dayItem = childView.dayItems[i]
                    break
                }
            }
        },
    },
    mounted(){
        if(this.optId === -1){
            this.getListInfo();
        }else if(this.navName === ""){
            this.setNavName("月视图");
        }
    },
}
</script>

<style scoped>
div.container{
    width: 100%;
    background: #FFFEF2;
}
div.header-date{
    width: 100%;
    height: 0.56rem;
    display: flex;
    justify-content: space-between;
}

div.top-left, div.top-right{
    height: 100%;
    flex-basis: 25%;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    box-sizing: border-box;
}
div.top-left{
    padding-left: 0.3rem;
}
div.top-center{
    height: 100%;
    flex-basis: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
div.top-right{
    padding-right: 0.5rem;
}
div.view-type{
    font-family: PF-Regular, sans-serif;
    font-weight: bold;
    font-size: 0.16rem;
    color: #333333;
    text-align: center;
    box-sizing: border-box;
}
div.bottom-border{
    width: 0.64rem;
    height: 0.07rem;
    background: url("../../assets/images/View/img-view-line.png");
    background-size: cover;
    margin-top: -0.04rem;
}


div.icon-prev-month, div.icon-next-month, div.icon-today-month{
    width: 0.34rem;
    height: 0.34rem;
    border-radius: 50%;
}
div.icon-prev-month{
    background: url("../../assets/images/View/icon-prev.png");
    background-size: cover;
}
div.text-title{
    font-size: 0.26rem;
    font-family: PF-Medium, sans-serif;
    font-weight: bold;
    color: #333333;
    line-height: 0.84rem;
    text-align: center;
    margin: 0 0.24rem;
}
div.icon-next-month{
    background: url("../../assets/images/View/icon-next.png");
    background-size: cover;
}
div.icon-today-month{
    background: url("../../assets/images/View/icon-today.png");
    background-size: cover;
    margin-left: 0.24rem;
    margin-right: 0.24rem;
}

div.top-right{
    justify-content: end;
}

div.item-category{
    width: 1.2rem;
    height: 0.41rem;
    background: url("../../assets/images/View/img-category.png");
    background-size: cover;

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.42rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.05rem;
}

div.icon-category{
    width: 0.08rem;
    height: 0.13rem;
    background: url("../../assets/images/View/icon-category.png");
    background-size: cover;
}

</style>